import React from 'react';
import { notifyError } from './notifyError';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    try {
      notifyError(error, { toastId: 'ui.errorBoundary' });
    } catch {
      // If toast system is broken, avoid infinite loops.
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            background: '#f3f4f6',
          }}
        >
          <div
            style={{
              background: '#ffffff',
              borderRadius: 16,
              padding: '28px 32px',
              boxShadow: '0 24px 60px rgba(148,163,184,0.45)',
              border: '1px solid rgba(209,213,219,0.9)',
              width: '100%',
              maxWidth: 560,
              color: '#111827',
            }}
          >
            <h2 style={{ margin: 0, marginBottom: 8, fontSize: 20, fontWeight: 700 }}>Something went wrong</h2>
            <p style={{ margin: 0, marginBottom: 18, fontSize: 14, color: '#6b7280' }}>
              Please refresh the page. If this keeps happening, try again in a few minutes.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 14px',
                borderRadius: 999,
                border: 'none',
                background: 'linear-gradient(135deg, #22c55e, #0ea5e9)',
                color: '#0b1120',
                fontWeight: 700,
                fontSize: 14,
                cursor: 'pointer',
                boxShadow: '0 12px 30px rgba(56,189,248,0.35)',
              }}
            >
              Refresh
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

